export function loadScript(src, attribute) {
  return new Promise((resolve, reject) => {
    let script = document.querySelector(`script[src="${src}"]`)
    if (script) {
      resolve(script)
      return
    }
    script = document.createElement('script')
    script.src = src
    if (attribute) {
      Object.keys(attribute).forEach((key) => {
        script[key] = attribute[key]
      })
    }
    script.onload = () => {
      resolve(script)
    }
    script.onerror = reject
    document.head.appendChild(script)
  })
}
